<template>
  <div class="smallheader">
    <div class="btn" @click="menuShow=true">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <transition name="el-zoom-in-top">
      <div class="menu flex flex-column flex-align-center" v-show="menuShow">
        <div class="logo">
          <img src="@/assets/smalllogo.png" alt="">
        </div>
        <div class="close el-icon-close" @click="menuShow=false"></div>
        <div class="list flex flex-column flex-justify-center">
          <router-link to="/">{{ $t('nav.home') }}</router-link>
          <router-link to="/about/1">{{ $t('nav.about.title') }}</router-link>
          <router-link to="/research/1">{{ $t('nav.research.title') }}</router-link>
          <a @click="gotoproduct">{{ $t('nav.products') }}</a>
          <a @click="gotonews">{{ $t('nav.news') }}</a>
          <router-link to="/job">{{ $t('nav.job') }}</router-link>
          <router-link to="/contact">{{ $t('nav.contact') }}</router-link>
          <div class="language flex flex-space-between">
            <a @click="language('zh-CN')">中</a>
            <a @click="language('en')">英</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getProductstypeUrl } from '@/util/lang.js'
export default {
  name: 'Header',
  data(){
    return{
      menuShow: false
    }
  },
  components: {
    
  },
  watch: {
    $route: 'menuhidden'
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      langProducttype: state => state.langProducttype,
      langNewtype: state => state.langNewtype
    }),
    productTypes () {
      return this.langProducttype[this.lang]
    },
    newsTypes () {
      return this.langNewtype[this.lang]
    }
  },
  methods: {
    ...mapActions([
      'setLang',
      'setLangProducttype'
    ]),
    menuhidden(){
      this.menuShow=false
    },
    gotoproduct(){
      this.$router.push({ name: 'products', params: { tid: this.productTypes[0].ID } })
    },
    gotonews(){
      this.$router.push({ name: 'news', params: { tid: this.newsTypes[0].ID } })
    },
    language (command) {
      this.setLang(command)
      this.$i18n.locale = command
      this.menuShow=false
      const url = getProductstypeUrl(command)
      if (this.langProducttype[command].length === 0) {
        this.$$axios.get(url).then(res => {
          this.setLangProducttype({
            lang: command,
            productstype: res.data
          })
        })
      }
    }
  },
  mounted(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smallheader{
  padding-right: 20px;
}
.smallheader .btn{
  position: relative;
  width: 31px;
  height: 31px;
}
.smallheader .btn span{
  position: absolute;
  left: 5px;
  height: 1px;
  background-color: #004b94;
}
.smallheader .btn span:nth-of-type(1){
  width: 21px;
  top: 5px;
}
.smallheader .btn span:nth-of-type(2){
  width: 19px;
  top: 15px;
}
.smallheader .btn span:nth-of-type(3){
  width: 15px;
  top: 25px;
}
.smallheader .menu{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.9);
  z-index: 999;
  padding: 15px;
  color: #fff;
}
.smallheader .menu .close{
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 24px;
}
.smallheader .menu .list{
  flex: auto;
}
.smallheader .menu .list a{
  font-size: 16px;
  color: #fff;
  line-height: 50px;
  text-align: center;
}
.smallheader .menu .list a:hover{
  color: #004b94;
}
</style>

